import { Box, Stack, styled } from "@mui/material";
import { customColors } from "models/customColors";

export const Container = styled(Stack)`
  flex: 1 0 auto;
  flex-direction: row;
  width: 100%;
  height: 100%;
  // min-height: 480px;
  justify-content: stretch;
  align-items: stretch;
`;

export const Role = styled(Box)`
  margin: 0;
  width: 100%;

  color: ${customColors.grayText};
  font-family: Inter;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  word-wrap: break-word;
`;

export const Email = styled(Role)`
  color: ${customColors.grayText};
  font-family: Inter;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  word-break: break-all;
`;

export const UserName = styled(Email)`
  margin-bottom: 0;
  color: ${customColors.text};
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`;

export const Recipient = styled(Email)`
  margin-bottom: 0;
  color: ${customColors.grayText};
  font-family: Inter;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`;

export const LogoutItem = styled(Stack)`
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
  padding: 12px;
  font-size: 14px;
  font-family: "Inter Medium";
  color: ${customColors.grayText};
  cursor: pointer;
  user-select: none;

  & path {
    fill: ${customColors.grayText};
  }

  &:hover {
    color: ${customColors.mainColor};

    path {
      fill: ${customColors.mainColor};
    }
  }
`;

export const Avatar = styled(Box)`
  display: flex;
  width: 60px;
  height: 60px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;

  font-family: Inter;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;

  border-radius: 4000px;
  border: 2px solid ${customColors.mainColor};
  color: #fff;
  background: ${customColors.mainColor};
`;
